import { IconNames } from '@dixa/lib-shared-habla';
import { QueueDashboardQueueType } from 'lib-dashboard-types';

export const queueTypePresets = new Map<
  QueueDashboardQueueType,
  { label: string; icon?: IconNames }
>([
  ['all', { label: 'All', icon: 'users' }],
  ['agent', { label: 'Assigned', icon: 'user' }],
  ['archived', { label: 'Archived', icon: 'archive' }],
]);
